export function getDateString(date: string) {
  try {
    const inputString = new Date(date);
    return inputString.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch (e) {
    throw new Error("date was not formatted correctly", e);
  }
}
